import { render, staticRenderFns } from "./MyCourseCard.vue?vue&type=template&id=1984bfbe&"
import script from "./MyCourseCard.vue?vue&type=script&lang=js&"
export * from "./MyCourseCard.vue?vue&type=script&lang=js&"
import style0 from "./MyCourseCard.vue?vue&type=style&index=0&id=1984bfbe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports